export default {
  state: {
    collection: [],
    clusters: []
  },
  getters: {
    collection: state => {
      return state.collection
    },
    clusters: state => {
      return state.clusters
    }
  },
  mutations: {
    setCollection(state, payload) {
      state.collection = payload
    },
    setClusters(state, payload) {
      state.clusters = payload
    }
  },
  actions: {
    setCollection({ commit }, data) {
      commit('setCollection', data)
    },
    setClusters({ commit }, data) {
      commit('setClusters', data)
    }
  }
}
